import React from 'react';
import styled from 'styled-components';
import { theme } from '../../utils/theme';

interface Props {
  type: 'radom' | 'play' | 'guitar' | 'notes' | 'midi' | 'material';
  className?: string;
  fill?: string;
  disabled?: boolean;
  Icon?: any;
}

export const Icon = styled(
  ({ type, className, fill = theme.colors.black, disabled, Icon }: Props) => {
    const getClassName = () => `${className} ${disabled ? 'disabled' : ''}`;

    if (Icon && type === 'material') {
      return (
        <Icon
          fontSize='large'
          className={className}
          style={{ color: disabled ? 'rgba(179, 179, 179, 0.3)' : fill }}
        />
      );
    }
    switch (type) {
      case 'radom':
        return (
          <svg
            fill={fill}
            className={getClassName()}
            role='img'
            focusable='false'
            aria-hidden='true'
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 14 14'
          >
            <path d='M 5.459789,4.64957 Q 5.058009,5.26564 4.542379,6.4777 4.395059,6.17636 4.294609,5.9922 4.194169,5.80805 4.023409,5.56698 3.852649,5.32591 3.681889,5.18863 3.511129,5.05136 3.260009,4.95426 3.008899,4.85716 2.714259,4.85716 H 1.214255 q -0.09375,0 -0.154018,-0.0603 Q 0.999969,4.73666 0.999969,4.64287 V 3.35716 q 0,-0.0937 0.06027,-0.15402 0.06027,-0.0603 0.154018,-0.0603 h 1.500004 q 1.6741,0 2.74553,1.5067 z m 7.54018,5.35045 q 0,0.0937 -0.0603,0.15402 l -2.14285,2.14285 q -0.0603,0.0603 -0.15402,0.0603 -0.0871,0 -0.15067,-0.0636 -0.0636,-0.0636 -0.0636,-0.15067 v -1.28571 q -0.21428,0 -0.5692,0.003 -0.35491,0.003 -0.54241,0.007 -0.1875,0.003 -0.48884,-0.007 -0.30133,-0.0101 -0.47544,-0.0335 -0.17411,-0.0234 -0.42857,-0.0703 -0.25447,-0.0469 -0.42188,-0.12388 -0.16741,-0.077 -0.38839,-0.19085 -0.22098,-0.11384 -0.39509,-0.26786 -0.17411,-0.15401 -0.3683,-0.35825 -0.1942,-0.20425 -0.375,-0.46541 0.39509,-0.62276 0.91071,-1.82812 0.14732,0.30134 0.24777,0.48549 0.10044,0.18415 0.2712,0.42522 0.17076,0.24107 0.34152,0.37835 0.17076,0.13728 0.42188,0.23438 0.25111,0.0971 0.54576,0.0971 h 1.71428 V 7.85687 q 0,-0.0937 0.0603,-0.15402 0.0603,-0.0603 0.15402,-0.0603 0.0803,0 0.16071,0.067 l 2.13616,2.13616 q 0.0603,0.0603 0.0603,0.15402 z m 0,-6 q 0,0.0937 -0.0603,0.15401 l -2.14285,2.14286 q -0.0603,0.0603 -0.15402,0.0603 -0.0871,0 -0.15067,-0.0636 -0.0636,-0.0636 -0.0636,-0.15067 V 4.85721 h -1.71428 q -0.32143,0 -0.58259,0.10045 -0.26116,0.10044 -0.46206,0.30134 -0.20089,0.20089 -0.34152,0.41183 -0.14062,0.21093 -0.30133,0.51897 -0.21429,0.41518 -0.52233,1.14509 -0.19419,0.44196 -0.33147,0.7433 -0.13728,0.30134 -0.36161,0.70313 -0.22433,0.40178 -0.42857,0.66964 -0.20424,0.26786 -0.49553,0.5558 -0.2913,0.28795 -0.60268,0.45871 -0.31139,0.17076 -0.71317,0.28125 -0.40179,0.11049 -0.85714,0.11049 H 1.214245 q -0.09375,0 -0.154018,-0.0603 -0.060258,-0.0603 -0.060258,-0.15404 V 9.35716 q 0,-0.0937 0.06027,-0.15402 0.06027,-0.0603 0.154018,-0.0603 h 1.500004 q 0.32142,0 0.58258,-0.10044 0.26117,-0.10045 0.46206,-0.30134 0.20089,-0.20089 0.34152,-0.41183 0.14062,-0.21094 0.30134,-0.51898 0.21428,-0.41517 0.52232,-1.14508 0.19419,-0.44197 0.33147,-0.74331 0.13728,-0.30134 0.36161,-0.70312 0.22433,-0.40179 0.42857,-0.66965 0.20424,-0.26785 0.49553,-0.5558 0.2913,-0.28795 0.60268,-0.45871 0.31139,-0.17075 0.71317,-0.28124 0.40179,-0.1105 0.85715,-0.1105 h 1.71428 V 1.85713 q 0,-0.0937 0.0603,-0.15402 0.0603,-0.0603 0.15402,-0.0603 0.0803,0 0.16071,0.067 l 2.13616,2.13616 q 0.0603,0.0603 0.0603,0.15402 z' />
          </svg>
        );

      case 'play':
        return (
          <svg
            height='32px'
            id='Layer_1'
            version='1.1'
            viewBox='0 0 32 32'
            width='32px'
            xmlns='http://www.w3.org/2000/svg'
            fill={fill}
            className={getClassName()}
          >
            <path d='M28.516,14L6,2.75C5.344,2.453,4.672,2,4,2C2.922,2,2,2.906,2,4v24c0,1.094,0.922,2,2,2c0.672,0,1.344-0.453,2-0.75  L28.516,18C29.063,17.734,30,17.188,30,16S29.063,14.266,28.516,14z M6,24.778V7.222L23.568,16L6,24.778z' />
          </svg>
        );

      case 'guitar':
        return (
          <svg
            className={className}
            version='1.1'
            id='Capa_1'
            xmlns='http://www.w3.org/2000/svg'
            x='0px'
            y='0px'
            width='30px'
            height='30px'
            viewBox='0 0 25.917 25.917'
          >
            <g>
              <path
                fill={fill}
                d='M9.547,20.221c0.118,0.119,0.118,0.31,0,0.428l-0.642,0.643c-0.118,0.117-0.311,0.117-0.428,0
         L4.625,17.44c-0.119-0.119-0.119-0.311,0-0.429l0.642-0.642c0.118-0.119,0.31-0.119,0.428,0L9.547,20.221z M25.917,2.413v0.003
         c0,0.256-0.098,0.511-0.293,0.706l-0.421,0.421l0.164,0.164c0.205,0.206,0.205,0.538,0,0.744c-0.102,0.102-0.237,0.153-0.372,0.153
         s-0.269-0.05-0.372-0.153l-0.164-0.164l-0.256,0.256l0.164,0.164c0.205,0.206,0.205,0.538,0,0.744
         c-0.102,0.102-0.237,0.153-0.372,0.153s-0.269-0.05-0.372-0.153l-0.164-0.164l-0.198,0.198c-0.259,0.259-0.622,0.329-0.952,0.245
         l-4.357,4.357c1.146,1.31,2.575,3.602,1.088,5.774c-1.014,1.483-2.584,1.178-3.474,2.103c-1.001,1.042-0.2,3.903-2.817,6.52
         c-0.985,0.985-2.11,1.433-3.301,1.433c-1.977,0-4.136-1.235-6.134-3.313c-3.332-3.203-4.498-6.82-1.881-9.436
         C4.05,10.55,6.909,11.351,7.95,10.35c0.927-0.89,0.642-2.44,2.124-3.453c0.668-0.457,1.347-0.64,2.004-0.64
         c1.479,0,2.849,0.921,3.752,1.71l4.358-4.358c-0.085-0.331-0.014-0.693,0.245-0.952l0.198-0.198l-0.164-0.164
         c-0.205-0.206-0.205-0.538,0-0.744c0.205-0.205,0.539-0.205,0.744,0l0.164,0.164l0.256-0.256l-0.164-0.164
         c-0.205-0.206-0.205-0.538,0-0.744c0.205-0.205,0.539-0.205,0.744,0l0.164,0.164l0.421-0.421c0.195-0.195,0.451-0.293,0.707-0.293
         h0.003c0.256,0,0.511,0.098,0.705,0.293l1.414,1.414C25.819,1.902,25.917,2.157,25.917,2.413z M16.96,11.079l-3.359,3.359
         c0.007,0.073,0.022,0.144,0.022,0.219c0,1.306-1.058,2.364-2.364,2.364s-2.364-1.058-2.364-2.364s1.058-2.364,2.364-2.364
         c0.076,0,0.148,0.015,0.223,0.022l3.356-3.357c-0.777-0.662-1.799-1.302-2.76-1.302c-0.428,0-0.825,0.129-1.214,0.395
         c-0.454,0.31-0.601,0.681-0.841,1.363c-0.209,0.595-0.47,1.336-1.104,1.944c-0.7,0.674-1.617,0.84-2.588,1.016
         c-1.218,0.221-2.598,0.471-3.908,1.782c-0.697,0.699-1.032,1.465-1.023,2.346c0.015,1.51,1.039,3.319,2.884,5.091
         c0.014,0.013,0.026,0.026,0.039,0.04c1.788,1.86,3.608,2.884,5.125,2.884c0.867,0,1.623-0.335,2.311-1.023
         c1.31-1.309,1.56-2.691,1.782-3.91c0.176-0.971,0.342-1.888,1.016-2.589c0.614-0.639,1.364-0.895,1.966-1.1
         c0.684-0.233,1.056-0.376,1.362-0.823C18.826,13.697,17.827,12.086,16.96,11.079z M21.652,3.689l2-2
         c0.117-0.117,0.117-0.307,0-0.424s-0.307-0.117-0.424,0l-2,2c-0.117,0.117-0.117,0.307,0,0.424
         c0.059,0.059,0.135,0.088,0.212,0.088C21.518,3.777,21.594,3.748,21.652,3.689z M24.652,2.265c-0.117-0.117-0.307-0.117-0.424,0
         l-2,2c-0.117,0.117-0.117,0.307,0,0.424c0.059,0.059,0.135,0.088,0.212,0.088s0.153-0.029,0.212-0.088l2-2
         C24.77,2.572,24.769,2.382,24.652,2.265z'
              />
            </g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
          </svg>
        );

      case 'notes':
        return (
          <svg
            className={className}
            fill={fill}
            version='1.1'
            width='25px'
            height='25px'
            id='Capa_1'
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 477.867 477.867'
            enableBackground={'new 0 0 477.867 477.867'}
          >
            <g>
              <g>
                <path
                  d='M472.184,4.347c-3.631-3.209-8.441-4.75-13.261-4.25l-307.2,34.133c-8.647,0.957-15.19,8.265-15.189,16.964V355.34
             c-15.468-9.256-33.174-14.102-51.2-14.012C38.281,341.329,0,371.946,0,409.595s38.281,68.267,85.333,68.267
             s85.333-30.601,85.333-68.267V151.889l273.067-30.413v199.68c-15.473-9.238-33.179-14.066-51.2-13.961
             c-47.053,0-85.333,30.618-85.333,68.267c0,37.649,38.281,68.267,85.333,68.267s85.333-30.601,85.333-68.267v-358.4
             C477.866,12.208,475.8,7.584,472.184,4.347z'
                />
              </g>
            </g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
          </svg>
        );

      case 'midi':
        return (
          <svg
            className={className}
            version='1.1'
            viewBox='0 0 1000 455'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              aria-label='M'
              text-data='M'
              d='M137,96h233c19.6,0,31,16.9,31,37v229h-65V163h-38v199h-59V163h-37v199h-65V96z'
            />
            <rect aria-label='I' text-data='I' x='433' y='96' width='65' height='266' />
            <path
              aria-label='D'
              text-data='D'
              d='M529,96h193c19.6,0,31,16.9,31,37v196c0,24.9-10.4,33-33,33H529V193h66v104h93V156H529V96z'
            />
            <rect aria-label='I' text-data='I' x='783' y='96' width='66' height='266' />
          </svg>
        );

      default:
        return <div>No Icon</div>;
    }
  }
)`
  &.disabled {
    color: rgba(179, 179, 179, 0.3);
    fill: rgba(198, 198, 198, 0.3);
  }
`;
